export default "__VITE_ASSET__862fc01f__"